import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Session from './pages/Session';

function App() {
  return (
    <ChakraProvider>
      <Router basename="/ia">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/session/:id" element={<Session />} />
        </Routes>
        <Footer />
      </Router>
    </ChakraProvider>
  );
}

export default App;